// Builds the burger-menu HTML for a row in the Fusion assignments table.
//
// Extracted from admin_survey_fusion.component.js (RPR-6331) so the RBAC gating is
// unit-testable in the karma harness (portal/test/fusion_action_menu.spec.js): the
// component controller is not reachable without angular-mocks, but this plain
// function is. It is deliberately a plain global (not an Angular service) so the
// already-oversized survey-fusion controller does not gain yet another injected
// dependency.
//
// `hasPermission` is the caller's $scope.has_permission predicate
// (permission-string -> boolean); `constants` is the CONSTANTS service, source of
// both the permission strings ($scope.PERMISSIONS = CONSTANTS.getPermissions()) and
// the third-party message.
globalThis.buildFusionActionMenu = function (row, hasPermission, constants) {
  const PERMISSIONS = constants.getPermissions();
  const menu = [
    '<div class=\'mat ui btn-group\'>',
    `<button type='button' class='btn mat ui small primary button dropdown-toggle' data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false' data-ng-disabled='ul_has_li_items("burger-menu-${row.id}") == false'>`,
    '<i class=\'fa fa-bars fa-fw\'></i>',
    '</button>',
    `<ul id="burger-menu-${row.id}" class="mat ui dropdown-menu dropdown-menu-right" style="min-width: 280px;">`
  ];

  // Fusion-specific actions (always shown)
  menu.push(
    `<li class='ms-2' data-ng-click='adminSurveyFusionCtrl.manageFusionRecord(${row.id})'>`,
    '<i class=\'fa fa-cog fa-fw me-2\'></i> Manage Payer Fusion Records</li>',
    `<li class='ms-2' data-ng-click='adminSurveyFusionCtrl.downloadTranscripts(${row.id})'>`,
    '<i class=\'fa fa-download fa-fw me-2\'></i> Download Transcripts</li>'
  );

  if (hasPermission(PERMISSIONS.CAN_UPDATE_ASSIGNED_PAYERS)) {
    const paymentDisabled = row.has_payment || row.is_third_party;
    let paymentTitle = '';
    if (row.is_third_party) {
      paymentTitle = constants.thirdPartyStakeholder.NO_PAYMENT_GENERATION;
    } else if (row.has_payment) {
      paymentTitle = 'Payment has already been generated';
    }
    const paymentLabel = '<i class=\'fa fa-credit-card fa-fw me-2\'></i>Generate Payments';
    // span re-enables pointer-events so the title tooltip still shows on the disabled li
    menu.push(paymentDisabled
      ? '<li class=\'ms-2 disabled text-muted\' style=\'pointer-events: none; opacity: 0.6;\'>'
        + `<span style='pointer-events: auto; cursor: not-allowed;' title="${paymentTitle}">`
        + `${paymentLabel}</span></li>`
      : `<li class='ms-2' data-ng-click='adminSurveyFusionCtrl.generatePayments(${row.id})'>`
        + `${paymentLabel}</li>`);
  }

  // Common payer actions - following the same permission checks as survey_manage_payer.js
  const showViewPayer = hasPermission(PERMISSIONS.CAN_VIEW_PAYER);
  const showEditPayer = hasPermission(PERMISSIONS.CAN_UPDATE_PAYER);
  const showAccessOnBehalf = !row.payer_locked && row.payer_active
    && hasPermission(PERMISSIONS.CAN_ACCESS_ON_BEHALF_OF_PAYER);

  // Separator before the common payer actions - only when at least one of them
  // follows, so a user without these permissions gets no trailing/duplicate rule.
  if (showViewPayer || showEditPayer || showAccessOnBehalf) {
    menu.push('<li><hr/></li>');
  }

  if (showViewPayer) {
    menu.push(
      `<li><a href='#/Admin/Payer/View/${row.payer}'>`,
      '<i class=\'fa fa-user fa-fw me-2\'></i> View Payer </a></li>'
    );
  }

  if (showEditPayer) {
    menu.push(
      `<li><a href='#/Admin/Payer/Edit/${row.payer}'>`,
      '<i class=\'fa fa-pencil fa-fw me-2\'></i> Edit Payer </a></li>'
    );
  }

  if (showAccessOnBehalf) {
    menu.push(
      `<li class='ms-2 payer-impersonate-link' data-ng-click='adminSurveyFusionCtrl.accessOnBehalfOf(${row.payer})'>`,
      '<i class=\'fa fa-user-secret fa-fw me-2\'></i> Access on Behalf of</li>'
    );
  }

  if (hasPermission(PERMISSIONS.CAN_UPDATE_ASSIGNED_PAYERS)) {
    // Separator before the remove action, then the remove item
    menu.push(
      '<li><hr/></li>',
      `<li class='ms-2' data-ng-click='adminSurveyFusionCtrl.removePayer(${row.id})'>`,
      '<i class=\'fa fa-remove fa-fw me-2\'></i>Remove</li>'
    );
  }

  menu.push('</ul></div>');

  return menu.join('\n');
};
